import { Toaster } from 'sonner';
import {
    commerceNotificationDesktopWidthClassName,
    commerceNotificationDismissLayoutClassName,
} from '@/components/toast/commerce-notification-styles';
import { dismissCloseButtonClassName } from '../ui/dismiss-close-button';
import { cn } from 'src/lib/utils';

/** Sonner toaster id for wishlist/cart success feedback (top-right). */
export const COMMERCE_FEEDBACK_TOASTER_ID = 'commerce-feedback';

/**
 * Dedicated toaster for commerce actions (wishlist save, add to cart).
 * Positioned top-right; styled separately from global center toasts.
 */
export function CommerceFeedbackToaster() {
    return (
        <Toaster
            id={COMMERCE_FEEDBACK_TOASTER_ID}
            className="commerce-feedback-toaster"
            expand
            position="top-right"
            closeButton
            toastOptions={{
                unstyled: true,
                classNames: {
                    toast: cn(commerceNotificationDesktopWidthClassName, 'relative'),
                    closeButton: cn(commerceNotificationDismissLayoutClassName, dismissCloseButtonClassName),
                },
            }}
        />
    );
}
